import React, { useMemo, useState } from "react";
import Swal from "sweetalert2";

const ChangeUserPassword = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const token = useMemo(() => {
    try {
      const s = localStorage.getItem("userDetails");
      if (!s) return "";
      const obj = JSON.parse(s);
      return obj?.token || "";
    } catch {
      return "";
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const eTrim = email.trim();
    const pTrim = password.trim();

    if (!pTrim) {
      Swal.fire("Oops!", "Please enter a password.", "error");
      return;
    }

    if (!eTrim) {
      Swal.fire("Oops!", "Please enter a valid email address.", "error");
      return;
    }

    setSubmitting(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_PREDICTIONS_API}/api/change-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          body: JSON.stringify({
            password: pTrim,
            email: eTrim,
            oldPassword: null,
            newPassword: null,
            userId: null,
          }),
        }
      );

      if (!response.ok) {
        Swal.fire("Oops!", "User not found.", "error");
        return;
      }

      await fetch(
        `${process.env.REACT_APP_PREDICTIONS_API}/api/member-connect`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userId: eTrim,
            groupId: "abcdef",
            mode: "004",
          }),
        }
      );

      const result = await Swal.fire(
        "Done!",
        "Password changed successfully.",
        "success"
      );
      if (result.isConfirmed) window.location.reload();
    } catch (error) {
      console.error("Error changing password:", error);
      Swal.fire("Oops!", "Something went wrong.", "error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="card profile-card card-bx">
          <form className="profile-form" onSubmit={handleSubmit}>
            <div className="card-body">
              <div>
                <label className="form-label">User Email</label>
                <input
                  type="email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoFocus
                  autoComplete="email"
                  disabled={submitting}
                />
              </div>

              <div style={{ marginTop: 12 }}>
                <label className="form-label">New Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="new-password"
                  disabled={submitting}
                />
              </div>
            </div>

            <div className="row" style={{ padding: "0 16px 16px 16px" }}>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting}
              >
                {submitting ? "Updating..." : "Update"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangeUserPassword;
